<template>
  <div>

    <transition name="slide-fade" appear enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutDown">
      <v-card @keyup.enter="signIn" width="300px" class="">

        <div class="pa-4 border-b--thin">
          <h3>Sign in</h3>
        </div>

        <div class="pa-4">
          <v-text-field
          v-model="email"
          :prepend-icon="'person'"
          :type="'email'"
          spellcheck="false"
          label="E-mail"
          color="green darken-1"
        ></v-text-field>
          <v-text-field
          v-model="password"
          :prepend-icon="'lock'"
          :append-icon="e3 ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="() => (e3 = !e3)"
          :type="e3 ? 'password' : 'text'"
          label="Password"
          spellcheck="false"
          hint="At least 8 characters"
          min="8"
          color="green darken-1"
          :error="error"
          :rules="rules"
        ></v-text-field>
            <v-btn 
            class="crx-gradient-green font-weight-bold white--text" 
            large
            block
            rounded
            @click="signIn"
            :loading="loading"
            >Sign in</v-btn>

          <br>
          <div class="div-align-text-center">
            <router-link 
            class="text-sans font-weight-medium"
            to="/auth/forgot-password">Forgot your password?</router-link>
          </div>
        </div>
      </v-card>
    </transition>

  </div>
</template>

<script>
export default {
  data () {
    return {
      email: localStorage.getItem('email'),
      password: '',
      e3: true,
      error: false,
      rules: [],
      loading: false
    }
  },
  methods: {
    signIn () {
      this.loading = true
      this.error = false
      var credentials = {email: this.email, password: this.password}
      this.$store.dispatch('auth/login', credentials)
        .then(
          () => {
            this.error = false
            this.rules = []
            localStorage.setItem('email', this.email)
            this.$router.push('/')
          }
        )
        .catch(
          error => {
            this.error = false
            this.rules = []
            this.$nextTick(() => {
              this.error = true
              // this.rules = [() => error.response.data.errors[0]]
            })
            console.log(error.response)
          }
        )
        .then(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
a {
  margin-left: auto;
  text-decoration: none;
  display:block;
  color: #999;
}

a:active {
  color: #43A047;
}

a:hover {
  color: #43A047;
  text-decoration: underline;
}

.div-align-text-center {
  text-align: center;
}
</style>
